"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _TooltipBodyStyled = require("../styled/TooltipBodyStyled");
// Nothing here on purpose, just keeping the namespace open.
// eslint-disable-next-line @typescript-eslint/no-empty-interface

const TooltipBody = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_TooltipBodyStyled.TooltipBodyStyled, (0, _extends2.default)({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
exports.TooltipBody = TooltipBody;
TooltipBody.displayName = "TooltipBody";
//# sourceMappingURL=TooltipBody.js.map